import { render, staticRenderFns } from "./Registro2.vue?vue&type=template&id=533fd83c&scoped=true&"
import script from "./Registro2.vue?vue&type=script&lang=js&"
export * from "./Registro2.vue?vue&type=script&lang=js&"
import style0 from "./Registro2.vue?vue&type=style&index=0&id=533fd83c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533fd83c",
  null
  
)

export default component.exports